/* MARSYU Compare Watches V1. Theme-only; no price calculation, cart calls or tracking. */
(function () {
  'use strict';

  function normalizeSelection(ids, validIds, maximum) {
    var allowed = new Set(Array.from(validIds || [], String));
    var result = [];
    (Array.isArray(ids) ? ids : []).forEach(function (id) {
      id = String(id);
      if (allowed.has(id) && result.indexOf(id) === -1 && result.length < (maximum || 3)) result.push(id);
    });
    return result;
  }

  function changeSelection(current, action, validIds, maximum) {
    var limit = maximum || 3;
    var allowed = new Set(Array.from(validIds || [], String));
    var ids = normalizeSelection(current, allowed, limit);
    var id = String(action.id || '');
    var oldId = String(action.oldId || '');
    if (action.type === 'clear') return { ids: [], reason: 'cleared' };
    if (action.type === 'default') return { ids: normalizeSelection(action.ids, allowed, limit), reason: 'default' };
    if (!allowed.has(id)) return { ids: ids, reason: 'invalid' };
    var index = ids.indexOf(id);
    if (action.type === 'remove' || (action.type === 'toggle' && index !== -1)) {
      return { ids: ids.filter(function (value) { return value !== id; }), reason: index === -1 ? 'unchanged' : 'removed' };
    }
    if (action.type === 'replace') {
      if (ids.indexOf(oldId) === -1) return { ids: ids, reason: 'invalid' };
      if (oldId === id) return { ids: ids, reason: 'unchanged' };
      if (index !== -1) return { ids: ids, reason: 'duplicate' };
      return { ids: ids.map(function (value) { return value === oldId ? id : value; }), reason: 'replaced' };
    }
    if (index !== -1) return { ids: ids, reason: 'duplicate' };
    if (ids.length >= limit) return { ids: ids, reason: 'limit' };
    return { ids: ids.concat(id), reason: 'added' };
  }

  function chooseVariant(product, variantId) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function (variant) { return String(variant.id) === String(variantId); }) ||
      variants.find(function (variant) { return variant.available === true; }) || variants[0] || product;
  }

  function variantTitle(title, locale) {
    var text = String(title || '');
    var colors = locale === 'de' ? {
      '粉红色': 'Rosa', '茶色': 'Hellbraun', '黑色': 'Schwarz', '棕色': 'Braun', '海军蓝': 'Marineblau'
    } : {
      '粉红色': 'Pink', '茶色': 'Tan', '黑色': 'Black', '棕色': 'Brown', '海军蓝': 'Navy'
    };
    Object.keys(colors).forEach(function (token) { text = text.split(token).join(colors[token]); });
    if (locale === 'de') {
      var phrases = {
        'rose gold': 'Roségold', 'steel bands': 'Stahlarmband', 'steel band': 'Stahlarmband',
        'link bracelet': 'Gliederarmband', 'leather-look band': 'Armband in Lederoptik',
        'leather band': 'Lederarmband', 'silicone band': 'Silikonarmband',
        'mesh band': 'Mesh-Armband', 'smooth band': 'glattes Armband',
        'leather-look': 'Lederoptik'
      };
      var english = { black: 'Schwarz', pink: 'Rosa', gold: 'Gold', silver: 'Silber', white: 'Weiß', blue: 'Blau', navy: 'Marineblau', brown: 'Braun', tan: 'Hellbraun', beige: 'Beige', grey: 'Grau', gray: 'Grau', orange: 'Orange', green: 'Grün', red: 'Rot', purple: 'Violett', silicone: 'Silikon', steel: 'Stahl', leather: 'Leder', mesh: 'Mesh' };
      var translations = Object.assign({}, english, phrases);
      var pattern = Object.keys(translations).sort(function (left, right) { return right.length - left.length; }).join('|');
      text = text.replace(new RegExp('\\b(' + pattern + ')\\b', 'gi'), function (token) { return translations[token.toLowerCase()]; });
    }
    return text;
  }

  function confirmedSummary(product) {
    var specs = product.specs || {};
    var keys = ['display', 'shape'];
    for (var index = 0; index < keys.length; index++) {
      var spec = specs[keys[index]];
      if (spec && spec.status === 'confirmed' && String(spec.text || '').trim()) return String(spec.text).trim();
    }
    return '';
  }

  /* The same state transitions used by the UI can be exercised without a DOM. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeSelection: normalizeSelection, changeSelection: changeSelection, chooseVariant: chooseVariant, variantTitle: variantTitle, confirmedSummary: confirmedSummary };
  }
  if (typeof document === 'undefined') return;

  var words = {
    en: {
      title: 'Compare MARSYU Watches', subtitle: 'Find the watch that fits your style and daily needs.',
      compare: 'Compare', selected: 'Selected', remove: 'Remove', clear: 'Clear all', open: 'Compare now',
      close: 'Close comparison', back: 'Back to watches', details: 'View details',
      variant: 'Style', replace: 'Replace model', add: 'Add a model', addPlaceholder: 'Choose another model',
      inStock: 'Available', outOfStock: 'Out of stock', currentPrice: 'Current price', notConfirmed: 'Not confirmed',
      noStyles: 'No styles currently available', shared: 'Shared features are muted to help you spot differences.',
      priceNote: 'Current store prices in {currency}. Select a style to see its price and availability. Any discount must be confirmed at checkout.',
      wellness: 'Health and activity features support general wellness information, not diagnosis or treatment. Features vary by model.',
      appNote: 'App names follow the supplied manuals. Use the app specified in the guide included with your watch; app and firmware versions can vary.',
      allSpecs: 'Show all specifications', fewerSpecs: 'Show fewer specifications',
      min: 'Choose at least 2 models to compare.', max: 'You can compare up to 3 different models. Remove or replace one to continue.',
      duplicate: 'This model is already selected.', invalid: 'This model is not in the current comparison list.',
      added: '{name} added to comparison.', removed: '{name} removed from comparison.',
      replaced: '{old} replaced with {name}.', cleared: 'Comparison cleared. Choose 2–3 models.',
      defaults: 'ET491, ET570 and MT500 selected.', selection: '{count} of 3 models selected.',
      comparing: 'Comparing',
      empty: 'Choose watches to start your comparison.', needOne: 'Add one more model to compare.',
      loadError: 'Comparison is unavailable right now. You can still view each watch on its product page.',
      rowLabel: 'Feature', overview: 'Watch & style', shape: 'Design', display: 'Display', health: 'Health & activity', calling: 'Bluetooth calling',
      app: 'Phone app', styles: 'Available styles', battery: 'Battery & charging', water: 'Water use & care',
      dimensions: 'Size & weight', compatibility: 'Phone compatibility', other: 'Other confirmed features',
      scroll: 'Swipe or scroll sideways to compare all selected watches.', demo: 'View suggested comparison'
    },
    de: {
      title: 'MARSYU Uhren vergleichen', subtitle: 'Finde die Uhr, die zu deinem Stil und Alltag passt.',
      compare: 'Vergleichen', selected: 'Ausgewählt', remove: 'Entfernen', clear: 'Alle entfernen', open: 'Jetzt vergleichen',
      close: 'Vergleich schließen', back: 'Zurück zu den Uhren', details: 'Details ansehen',
      variant: 'Ausführung', replace: 'Modell ersetzen', add: 'Modell hinzufügen', addPlaceholder: 'Weiteres Modell wählen',
      inStock: 'Verfügbar', outOfStock: 'Ausverkauft', currentPrice: 'Aktueller Preis', notConfirmed: 'Nicht bestätigt',
      noStyles: 'Derzeit keine Ausführung verfügbar', shared: 'Gleiche Merkmale sind dezenter dargestellt, damit Unterschiede leichter auffallen.',
      priceNote: 'Aktuelle Shoppreise in {currency}. Wähle eine Ausführung für Preis und Verfügbarkeit. Ein Rabatt muss im Checkout bestätigt werden.',
      wellness: 'Gesundheits- und Aktivitätsfunktionen dienen der allgemeinen Information zum Wohlbefinden, nicht der Diagnose oder Behandlung. Funktionen unterscheiden sich je nach Modell.',
      appNote: 'Die App-Namen entsprechen den mitgelieferten Anleitungen. Verwende die App aus der Anleitung deiner Uhr; App- und Firmware-Versionen können abweichen.',
      allSpecs: 'Alle technischen Daten anzeigen', fewerSpecs: 'Weniger technische Daten anzeigen',
      min: 'Wähle mindestens 2 Modelle für den Vergleich.', max: 'Du kannst höchstens 3 verschiedene Modelle vergleichen. Entferne oder ersetze zuerst eines.',
      duplicate: 'Dieses Modell ist bereits ausgewählt.', invalid: 'Dieses Modell ist nicht in der aktuellen Vergleichsliste.',
      added: '{name} wurde zum Vergleich hinzugefügt.', removed: '{name} wurde aus dem Vergleich entfernt.',
      replaced: '{old} wurde durch {name} ersetzt.', cleared: 'Vergleich geleert. Wähle 2–3 Modelle.',
      defaults: 'ET491, ET570 und MT500 ausgewählt.', selection: '{count} von 3 Modellen ausgewählt.',
      comparing: 'Im Vergleich',
      empty: 'Wähle Uhren für deinen Vergleich.', needOne: 'Füge ein weiteres Modell zum Vergleich hinzu.',
      loadError: 'Der Vergleich ist derzeit nicht verfügbar. Die Uhren findest du weiterhin auf ihren Produktseiten.',
      rowLabel: 'Merkmal', overview: 'Uhr & Ausführung', shape: 'Design', display: 'Display', health: 'Gesundheit & Aktivität', calling: 'Bluetooth-Telefonie',
      app: 'Smartphone-App', styles: 'Verfügbare Ausführungen', battery: 'Akku & Laden', water: 'Wasserkontakt & Pflege',
      dimensions: 'Maße & Gewicht', compatibility: 'Smartphone-Kompatibilität', other: 'Weitere bestätigte Funktionen',
      scroll: 'Wische oder scrolle seitlich, um alle ausgewählten Uhren zu vergleichen.', demo: 'Vorgeschlagenen Vergleich ansehen'
    }
  };
  var coreRows = ['shape', 'display', 'health', 'calling', 'app', 'styles'];
  var extraRows = ['battery', 'water', 'dimensions', 'compatibility', 'other'];
  var instances = new Set();

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function setup(root) {
    if (root.dataset.compareReady === 'true') return;
    var source = root.querySelector('script[data-compare-data]');
    var picker = root.querySelector('[data-compare-picker]');
    var status = root.querySelector('[data-compare-status]');
    var tray = root.querySelector('[data-compare-tray]');
    var chips = root.querySelector('[data-compare-chips]');
    var openButton = root.querySelector('[data-compare-open]');
    var clearButton = root.querySelector('[data-compare-clear]');
    var dialog = root.querySelector('[data-compare-dialog]');
    var view = root.querySelector('[data-compare-view]');
    if (!source || !picker || !status || !tray || !chips || !openButton || !clearButton || !dialog || !view) return;
    var data;
    try { data = JSON.parse(source.textContent); } catch (error) {
      status.textContent = words.en.loadError;
      return;
    }
    var t = words[data.locale === 'de' ? 'de' : 'en'];
    var products = [];
    var byId = new Map();
    (Array.isArray(data.products) ? data.products : []).forEach(function (product) {
      if (!product || !product.id || byId.has(String(product.id))) return;
      product.id = String(product.id);
      byId.set(product.id, product);
      products.push(product);
    });
    if (!products.length) {
      status.textContent = t.loadError;
      return;
    }
    root.dataset.compareReady = 'true';
    var scope = root.closest('marsyu-black-friday') || root;
    var validIds = new Set(byId.keys());
    var storageKey = 'marsyu-compare-v1-models';
    var stored;
    try { stored = window.sessionStorage.getItem(storageKey); } catch (error) { stored = null; }
    var selected;
    if (stored !== null) {
      try { selected = normalizeSelection(JSON.parse(stored), validIds, 3); } catch (error) { selected = normalizeSelection(data.defaultIds, validIds, 3); }
    } else selected = normalizeSelection(data.defaultIds, validIds, 3);
    var variants = new Map();
    products.forEach(function (product) { variants.set(product.id, String(product.variantId || '')); });
    var expanded = false;
    var message = '';
    var returnFocus = null;
    var isOpen = false;
    var titleId = (root.id || 'marsyu-compare') + '-dialog-title';
    dialog.setAttribute('aria-labelledby', titleId);
    dialog.setAttribute('aria-modal', 'true');
    root.querySelectorAll('[data-compare-close]').forEach(function (button) { button.setAttribute('aria-label', t.close); });
    openButton.textContent = t.open;
    clearButton.textContent = t.clear;
    var demoButton = root.querySelector('[data-compare-demo]');
    if (demoButton && !demoButton.textContent.trim()) demoButton.textContent = t.demo;

    function format(text, values) {
      Object.keys(values || {}).forEach(function (key) { text = text.replace('{' + key + '}', values[key]); });
      return text;
    }
    function currentVariant(product) { return chooseVariant(product, variants.get(product.id)); }
    function name(id) { return byId.has(String(id)) ? byId.get(String(id)).name : ''; }
    function available(variant) { return variant.available === true; }
    function save() {
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(selected)); } catch (error) { /* Memory selection remains usable. */ }
    }
    function announce(text) {
      message = text;
      status.textContent = text;
      var dialogStatus = view.querySelector('[data-compare-dialog-status]');
      if (dialogStatus) dialogStatus.textContent = text;
    }
    function focusKey(node, key) { node.dataset.compareFocus = key; return node; }
    function restoreFocus(key) {
      if (!key) return false;
      var match = Array.from(root.querySelectorAll('[data-compare-focus]')).find(function (node) { return node.dataset.compareFocus === key; });
      if (match) match.focus({ preventScroll: true });
      return Boolean(match);
    }
    function button(text, className) {
      var node = element('button', className, text);
      node.type = 'button';
      return node;
    }
    function image(product, variant, className) {
      var media = variant.image && variant.image.src ? variant.image : product.image;
      if (!media || !media.src) return element('div', className + ' msy-compare-image-empty', product.name);
      var img = element('img', className);
      img.src = media.src;
      img.alt = product.name + (variant.title ? ' — ' + variantTitle(variant.title, data.locale) : '');
      img.width = 240;
      img.height = 240;
      img.loading = 'lazy';
      img.decoding = 'async';
      return img;
    }
    function stock(variant) {
      return element('span', 'msy-compare-stock' + (available(variant) ? '' : ' is-sold-out'), available(variant) ? t.inStock : t.outOfStock);
    }
    function details(product, variant) {
      var link = element('a', 'msy-compare-details', t.details);
      link.href = variant.url || product.url;
      link.setAttribute('aria-label', t.details + ' — ' + product.name + (variant.title ? ', ' + variantTitle(variant.title, data.locale) : ''));
      return link;
    }
    function variantSelect(product, location) {
      var list = Array.isArray(product.variants) ? product.variants : [];
      if (!list.length) return null;
      var label = element('label', 'msy-compare-field');
      label.appendChild(element('span', 'msy-compare-field-label', t.variant));
      var select = focusKey(element('select', 'msy-compare-select'), location + '-variant-' + product.id);
      select.dataset.compareVariant = product.id;
      select.setAttribute('aria-label', t.variant + ' — ' + product.name);
      var current = currentVariant(product);
      list.forEach(function (variant) {
        var option = element('option', '', (variantTitle(variant.title, data.locale) || product.name) + (available(variant) ? '' : ' — ' + t.outOfStock));
        option.value = String(variant.id);
        option.selected = String(variant.id) === String(current.id || current.variantId);
        select.appendChild(option);
      });
      label.appendChild(select);
      return label;
    }
    function renderPicker() {
      var fragment = document.createDocumentFragment();
      products.forEach(function (product) {
        var variant = currentVariant(product);
        var chosen = selected.indexOf(product.id) !== -1;
        var card = element('article', 'msy-compare-card' + (chosen ? ' is-selected' : ''));
        card.appendChild(image(product, variant, 'msy-compare-card-image'));
        var body = element('div', 'msy-compare-card-body');
        body.appendChild(element('h3', 'msy-compare-card-title', product.name));
        body.appendChild(element('p', 'msy-compare-card-price', variant.price || product.price || t.notConfirmed));
        body.appendChild(stock(variant));
        var selector = variantSelect(product, 'picker');
        if (selector) body.appendChild(selector);
        var toggle = focusKey(button(chosen ? t.selected + ' ✓' : t.compare + ' +', 'msy-compare-toggle'), 'picker-toggle-' + product.id);
        toggle.dataset.compareToggle = product.id;
        toggle.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        toggle.setAttribute('aria-label', (chosen ? t.remove : t.compare) + ' — ' + product.name);
        body.appendChild(toggle);
        body.appendChild(details(product, variant));
        card.appendChild(body);
        fragment.appendChild(card);
      });
      picker.replaceChildren(fragment);
    }
    function renderTray() {
      tray.hidden = selected.length === 0;
      var fragment = document.createDocumentFragment();
      selected.forEach(function (id) {
        var chip = element('span', 'msy-compare-chip');
        chip.appendChild(element('span', '', name(id)));
        var remove = focusKey(button('×', 'msy-compare-chip-remove'), 'tray-remove-' + id);
        remove.dataset.compareRemove = id;
        remove.setAttribute('aria-label', t.remove + ' ' + name(id));
        chip.appendChild(remove);
        fragment.appendChild(chip);
      });
      chips.replaceChildren(fragment);
      openButton.disabled = selected.length < 2;
      openButton.setAttribute('aria-describedby', status.id || (status.id = (root.id || 'marsyu-compare') + '-status'));
      scope.querySelectorAll('[data-msy-compare-toggle]').forEach(function (toggle) {
        var id = String(toggle.dataset.msyCompareToggle || '');
        if (!validIds.has(id)) return;
        var chosen = selected.indexOf(id) !== -1;
        toggle.disabled = false;
        toggle.classList.toggle('is-selected', chosen);
        toggle.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        toggle.textContent = chosen ? t.selected + ' ✓' : t.compare + ' +';
        toggle.setAttribute('aria-label', (chosen ? t.remove : t.compare) + ' — ' + name(id));
      });
      root.classList.toggle('has-selection', selected.length > 0);
    }
    function specification(product, key) {
      if (key === 'styles') {
        var styles = (product.variants || []).filter(available).map(function (variant) { return variantTitle(variant.title, data.locale); }).filter(Boolean);
        return { text: styles.length ? styles.join(' · ') : t.noStyles, status: 'confirmed' };
      }
      var spec = product.specs && product.specs[key];
      if (!spec || !String(spec.text || '').trim()) return { text: t.notConfirmed, status: 'unconfirmed' };
      return { text: String(spec.text), status: spec.status || 'unconfirmed' };
    }
    function modelSelect(product) {
      var label = element('label', 'msy-compare-field msy-compare-replace-field');
      label.appendChild(element('span', 'msy-compare-field-label', t.replace));
      var select = focusKey(element('select', 'msy-compare-select'), 'dialog-replace-' + product.id);
      select.dataset.compareReplace = product.id;
      select.setAttribute('aria-label', t.replace + ' — ' + product.name);
      products.forEach(function (candidate) {
        if (candidate.id !== product.id && selected.indexOf(candidate.id) !== -1) return;
        var option = element('option', '', candidate.name + (candidate.available === true ? '' : ' — ' + t.outOfStock));
        option.value = candidate.id;
        option.selected = candidate.id === product.id;
        select.appendChild(option);
      });
      label.appendChild(select);
      return label;
    }
    function renderDialog() {
      var fragment = document.createDocumentFragment();
      fragment.appendChild(element('h2', 'msy-compare-dialog-title', t.title));
      fragment.lastChild.id = titleId;
      fragment.appendChild(element('p', 'msy-compare-dialog-subtitle', t.subtitle));
      if (selected.length) fragment.appendChild(element('p', 'msy-compare-model-summary', t.comparing + ': ' + selected.map(name).join(' · ')));
      var toolbar = element('div', 'msy-compare-dialog-toolbar');
      var back = focusKey(button('← ' + t.back, 'msy-compare-back'), 'dialog-back');
      back.dataset.compareBack = '';
      toolbar.appendChild(back);
      var clear = focusKey(button(t.clear, 'msy-compare-clear-dialog'), 'dialog-clear');
      clear.dataset.compareClearDialog = '';
      clear.disabled = selected.length === 0;
      toolbar.appendChild(clear);
      if (selected.length < 3) {
        var addLabel = element('label', 'msy-compare-field msy-compare-add-field');
        addLabel.appendChild(element('span', 'msy-compare-field-label', t.add));
        var addSelect = focusKey(element('select', 'msy-compare-select'), 'dialog-add');
        addSelect.dataset.compareAdd = '';
        addSelect.setAttribute('aria-label', t.add);
        var placeholder = element('option', '', t.addPlaceholder);
        placeholder.value = '';
        addSelect.appendChild(placeholder);
        products.forEach(function (product) {
          if (selected.indexOf(product.id) !== -1) return;
          var option = element('option', '', product.name + (product.available === true ? '' : ' — ' + t.outOfStock));
          option.value = product.id;
          addSelect.appendChild(option);
        });
        addLabel.appendChild(addSelect);
        toolbar.appendChild(addLabel);
      }
      fragment.appendChild(toolbar);
      var dialogStatus = element('p', 'msy-compare-dialog-status', message || format(t.selection, { count: selected.length }));
      dialogStatus.dataset.compareDialogStatus = '';
      dialogStatus.setAttribute('role', 'status');
      fragment.appendChild(dialogStatus);
      if (selected.length) {
        if (selected.length < 2) fragment.appendChild(element('p', 'msy-compare-help', t.needOne));
        fragment.appendChild(element('p', 'msy-compare-scroll-hint', t.scroll));
        var wrap = element('div', 'msy-compare-table-wrap');
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', t.title + '. ' + t.scroll);
        var table = element('table', 'msy-compare-table');
        table.style.setProperty('--msy-compare-count', String(selected.length));
        table.style.setProperty('--msy-compare-table-width', String(150 + selected.length * 240) + 'px');
        table.style.setProperty('--msy-compare-table-width-mobile', String(112 + selected.length * 220) + 'px');
        var caption = element('caption', 'msy-compare-sr-only', t.title);
        table.appendChild(caption);
        var head = element('thead');
        var row = element('tr');
        var corner = element('th', 'msy-compare-row-label', t.rowLabel);
        corner.scope = 'col';
        row.appendChild(corner);
        var overviewRow = element('tr', 'msy-compare-overview-row');
        var overviewLabel = element('th', 'msy-compare-row-label', t.overview);
        overviewLabel.scope = 'row';
        overviewRow.appendChild(overviewLabel);
        selected.forEach(function (id) {
          var product = byId.get(id);
          var variant = currentVariant(product);
          var modelHeader = element('th', 'msy-compare-model-heading');
          modelHeader.scope = 'col';
          var top = element('div', 'msy-compare-model-title-row');
          top.appendChild(element('span', 'msy-compare-model-name', product.name));
          var remove = focusKey(button('×', 'msy-compare-model-remove'), 'dialog-remove-' + id);
          remove.dataset.compareRemove = id;
          remove.setAttribute('aria-label', t.remove + ' ' + product.name);
          top.appendChild(remove);
          modelHeader.appendChild(top);
          var summary = confirmedSummary(product);
          if (summary) modelHeader.appendChild(element('span', 'msy-compare-model-difference', summary));
          row.appendChild(modelHeader);
          var cell = element('td', 'msy-compare-model-head');
          cell.appendChild(image(product, variant, 'msy-compare-model-image'));
          cell.appendChild(element('span', 'msy-compare-price-label msy-compare-sr-only', t.currentPrice));
          cell.appendChild(element('strong', 'msy-compare-model-price', variant.price || product.price || t.notConfirmed));
          cell.appendChild(stock(variant));
          var variantField = variantSelect(product, 'dialog');
          if (variantField) cell.appendChild(variantField);
          cell.appendChild(details(product, variant));
          cell.appendChild(modelSelect(product));
          overviewRow.appendChild(cell);
        });
        head.appendChild(row);
        table.appendChild(head);
        var body = element('tbody');
        body.appendChild(overviewRow);
        coreRows.concat(expanded ? extraRows : []).forEach(function (key) {
          var specs = selected.map(function (id) { return specification(byId.get(id), key); });
          var shared = specs.length > 1 && specs.every(function (spec) { return spec.text.trim().toLowerCase() === specs[0].text.trim().toLowerCase() && spec.status === specs[0].status; });
          var featureRow = element('tr', shared ? 'is-shared' : 'is-different');
          var heading = element('th', 'msy-compare-row-label', t[key]);
          heading.scope = 'row';
          featureRow.appendChild(heading);
          specs.forEach(function (spec) {
            var cell = element('td', 'msy-compare-spec' + (spec.status === 'unconfirmed' ? ' is-unconfirmed' : ''));
            cell.appendChild(element('span', '', spec.text));
            if (spec.status === 'unconfirmed' && spec.text.trim().toLowerCase() !== t.notConfirmed.toLowerCase()) cell.appendChild(element('span', 'msy-compare-unconfirmed-label', t.notConfirmed));
            featureRow.appendChild(cell);
          });
          body.appendChild(featureRow);
        });
        table.appendChild(body);
        wrap.appendChild(table);
        fragment.appendChild(wrap);
        var expand = focusKey(button(expanded ? t.fewerSpecs + ' −' : t.allSpecs + ' +', 'msy-compare-expand'), 'dialog-expand');
        expand.dataset.compareExpand = '';
        expand.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        fragment.appendChild(expand);
        fragment.appendChild(element('p', 'msy-compare-shared-note', t.shared));
      } else fragment.appendChild(element('p', 'msy-compare-empty', t.empty));
      fragment.appendChild(element('p', 'msy-compare-price-note', format(t.priceNote, { currency: String(data.currency || '') })));
      fragment.appendChild(element('p', 'msy-compare-wellness', t.wellness));
      fragment.appendChild(element('p', 'msy-compare-app-note', t.appNote));
      view.replaceChildren(fragment);
    }
    function render() {
      var active = document.activeElement;
      var key = active && active.dataset ? active.dataset.compareFocus : null;
      var hadDialogFocus = isOpen && active && dialog.contains(active);
      var hadRootFocus = active && root.contains(active);
      var wrap = view.querySelector('.msy-compare-table-wrap');
      var scroll = wrap ? { left: wrap.scrollLeft, top: wrap.scrollTop } : null;
      renderPicker();
      renderTray();
      if (isOpen) {
        renderDialog();
        var newWrap = view.querySelector('.msy-compare-table-wrap');
        if (newWrap && scroll) { newWrap.scrollLeft = scroll.left; newWrap.scrollTop = scroll.top; }
      }
      status.textContent = message || format(t.selection, { count: selected.length });
      var restoredFocus = restoreFocus(key);
      if (!restoredFocus && hadDialogFocus) {
        var fallback = view.querySelector('[data-compare-add]') || view.querySelector('[data-compare-back]');
        if (fallback) fallback.focus({ preventScroll: true });
      } else if (!restoredFocus && key && hadRootFocus && (!active || !active.isConnected)) {
        var rootFallback = selected.length ? clearButton : picker.querySelector('button');
        if (rootFallback) rootFallback.focus({ preventScroll: true });
      }
    }
    function apply(action) {
      var result = changeSelection(selected, action, validIds, 3);
      selected = result.ids;
      var text;
      if (result.reason === 'limit') text = t.max;
      else if (result.reason === 'duplicate') text = t.duplicate;
      else if (result.reason === 'invalid') text = t.invalid;
      else if (result.reason === 'cleared') text = t.cleared;
      else if (result.reason === 'default') text = t.defaults;
      else if (result.reason === 'replaced') text = format(t.replaced, { old: name(action.oldId), name: name(action.id) });
      else if (result.reason === 'added' || result.reason === 'removed') text = format(t[result.reason], { name: name(action.id) });
      else text = format(t.selection, { count: selected.length });
      message = text;
      save();
      render();
      announce(text);
      return result;
    }
    function closeDialog() {
      if (!isOpen) return;
      isOpen = false;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      var target = returnFocus && returnFocus.isConnected && !returnFocus.disabled ? returnFocus : openButton;
      if (!target || target.disabled || target.closest('[hidden]')) target = picker.querySelector('button');
      if (target) target.focus({ preventScroll: true });
    }
    function openDialog(trigger) {
      if (selected.length < 2) { announce(t.min); return; }
      if (isOpen) return;
      returnFocus = trigger || document.activeElement;
      isOpen = true;
      renderDialog();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var close = root.querySelector('[data-compare-close]');
      if (close) close.focus({ preventScroll: true });
    }
    function onClick(event) {
      var target = event.target.closest('button');
      if (!target || !scope.contains(target)) return;
      if (target.hasAttribute('data-msy-compare-toggle')) {
        var externalId = String(target.dataset.msyCompareToggle || '');
        if (!validIds.has(externalId)) return;
        event.preventDefault();
        apply({ type: 'toggle', id: externalId });
      } else if (root.contains(target)) {
        if (target.hasAttribute('data-compare-toggle')) apply({ type: 'toggle', id: target.dataset.compareToggle });
        else if (target.hasAttribute('data-compare-remove')) apply({ type: 'remove', id: target.dataset.compareRemove });
        else if (target.hasAttribute('data-compare-clear') || target.hasAttribute('data-compare-clear-dialog')) {
          apply({ type: 'clear' });
          if (isOpen) closeDialog();
        } else if (target.hasAttribute('data-compare-open')) openDialog(target);
        else if (target.hasAttribute('data-compare-close') || target.hasAttribute('data-compare-back')) closeDialog();
        else if (target.hasAttribute('data-compare-demo')) {
          apply({ type: 'default', ids: data.defaultIds });
          openDialog(target);
        } else if (target.hasAttribute('data-compare-expand')) {
          expanded = !expanded;
          render();
        }
      }
    }
    function onChange(event) {
      var target = event.target;
      if (!root.contains(target) || target.tagName !== 'SELECT') return;
      if (target.hasAttribute('data-compare-variant')) {
        var product = byId.get(String(target.dataset.compareVariant));
        if (!product || !(product.variants || []).some(function (variant) { return String(variant.id) === target.value; })) return;
        variants.set(product.id, target.value);
        render();
      } else if (target.hasAttribute('data-compare-replace')) apply({ type: 'replace', oldId: target.dataset.compareReplace, id: target.value });
      else if (target.hasAttribute('data-compare-add') && target.value) apply({ type: 'add', id: target.value });
    }
    function onCancel(event) { event.preventDefault(); closeDialog(); }
    function onNativeClose() { if (isOpen) closeDialog(); }
    function onDialogKey(event) {
      if (event.key === 'Escape') { event.preventDefault(); closeDialog(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], select:not([disabled]), [tabindex="0"]')).filter(function (node) { return node.getClientRects().length > 0; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    scope.addEventListener('click', onClick);
    scope.addEventListener('change', onChange);
    dialog.addEventListener('cancel', onCancel);
    dialog.addEventListener('close', onNativeClose);
    dialog.addEventListener('keydown', onDialogKey);
    root._marsyuCompareDestroy = function () {
      if (isOpen) closeDialog();
      scope.removeEventListener('click', onClick);
      scope.removeEventListener('change', onChange);
      dialog.removeEventListener('cancel', onCancel);
      dialog.removeEventListener('close', onNativeClose);
      dialog.removeEventListener('keydown', onDialogKey);
      delete root.dataset.compareReady;
      delete root._marsyuCompareDestroy;
      instances.delete(root);
    };
    instances.add(root);
    render();
  }

  function initialize(container) {
    if (container.matches && container.matches('[data-marsyu-compare]')) setup(container);
    container.querySelectorAll('[data-marsyu-compare]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (root) { if (event.target.contains(root) && root._marsyuCompareDestroy) root._marsyuCompareDestroy(); });
  });
})();
